const ACTIVE_CLASS = "is-active";

export function getTargetContainers(targetSelector, targetContentSelector, matchElements) {
    const targetContainers = [];
    const singleIdTarget = document.getElementById(targetSelector);
    if (singleIdTarget) targetContainers.push(singleIdTarget);
    if (targetContainers.length < 1) {
        const containers = document.querySelectorAll(targetSelector);
        if (containers && containers.length > 0) {
            containers.forEach((container) => targetContainers.push(container));
        }
    }

    const contentElementList = [];
    for(const container of targetContainers) {
        const contentElements = container.querySelectorAll(targetContentSelector);
        if (matchElements && matchElements.length !== contentElements.length) {
            console.error(`Error: target container count mismatch, ${matchElements.length} vs ${contentElements.length}`, container);
        }
        contentElementList.push(contentElements);
    }

    return contentElementList;
}

export function getTargetContainerSyncHandler(targetContainers, activeClass=ACTIVE_CLASS) {
    return (index) => {
        targetContainers.forEach((contentElements) => {
            contentElements.forEach((content, i) => {
                content.classList.toggle(activeClass, i === index);
            });
        });
    }
}
